<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>
<div class="container">
    <h1 class="title-default">Master</h1>
    <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Master</span>! Aqui tem todos as opções de configuração da sua empresa</p>
    <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
</div>
